<template>
    <div class="sag-form-select">
        <b-form-select 
            v-on="$listeners"
            v-bind="$attrs"
        >

        </b-form-select>
    </div>
</template>
<script>
import { 
    BRow, 
    BCol,
    BFormSelect
} from 'bootstrap-vue'

export default {
    components: {
        BFormSelect
    },
    props: {
        FieldNo: {
            type: String,
            required: true
        }
    },
    setup(){

        return {

        }
    }
}
</script>